import { Box, Flex, List, PageWrapper, Spacing } from '@approvalmax/ui/src/components';
import range from 'lodash/range';
import { Fragment, memo } from 'react';
import Skeleton from 'react-loading-skeleton';

const Loading = memo(() => {
    return (
        <PageWrapper>
            <PageWrapper.Content>
                <Flex container spacing='16'>
                    <Flex size={15} block>
                        <Box bordered radius='small' spacing='24'>
                            <Flex>
                                <Skeleton width={40} height={40} borderRadius={50} />

                                <Flex direction='column' grow={1} spacing='4'>
                                    <Skeleton width='80%' height={20} />

                                    <Skeleton width='60%' height={12} />
                                </Flex>

                                <Skeleton width={24} height={24} />
                            </Flex>

                            {range(2).map((index) => (
                                <Fragment key={index}>
                                    <Spacing height={40} />

                                    <Flex>
                                        <Skeleton width={20} height={20} />

                                        <Flex grow={1} block>
                                            <Skeleton width='50%' height={20} />
                                        </Flex>
                                    </Flex>

                                    <Spacing height={32} />

                                    <Flex>
                                        <Flex width={20} block />

                                        <Flex grow={1} block>
                                            <List divider removeLastDivider removeLastSpacing spacing='12 0'>
                                                {range(4 - index).map((itemIndex) => (
                                                    <List.Item key={itemIndex}>
                                                        <Flex spacing='8' key={itemIndex}>
                                                            <Flex grow={1} block>
                                                                <Skeleton width='40%' height={12} />
                                                            </Flex>

                                                            <Skeleton width={50} height={12} />

                                                            <Skeleton width={12} height={12} borderRadius={50} />
                                                        </Flex>
                                                    </List.Item>
                                                ))}
                                            </List>
                                        </Flex>
                                    </Flex>
                                </Fragment>
                            ))}
                        </Box>
                    </Flex>

                    <Flex size={9} block>
                        <Box bordered radius='small' spacing='24'>
                            <Flex alignItems='center'>
                                <Flex grow={1} block>
                                    <Skeleton width='70%' height={24} />
                                </Flex>

                                <Skeleton width={76} height={28} />
                            </Flex>

                            <Spacing height={16} />

                            <List spacing='2 0'>
                                {range(4).map((index) => (
                                    <List.Item key={index}>
                                        <Skeleton height={16} width={`${100 / index}%`} />
                                    </List.Item>
                                ))}
                            </List>
                        </Box>
                    </Flex>
                </Flex>
            </PageWrapper.Content>
        </PageWrapper>
    );
});

export default Loading;
